// const Home = () =>
//   import(/* webpackChunkName: "sf-home" */ "@/esf_antarctica_lederhosenland/core/views/Home.vue");

const BrandList = () =>
  import ("../core/components/brands/BrandList.vue");

const BrandsDetail = ()=>
  import("../core/components/brands/BrandsDetail.vue");

const Home = () =>
  import(/* webpackChunkName: "sf-home" */ "@/esf_antarctica_lederhosenland/core/views/home/Home.vue");

const Blogs = () =>
  import(
    /* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/blog/Blogs.vue"
  );

const Blog = () =>
  import(
    /* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/blog/Blog.vue"
  );
const CreateAccount = () =>
  import(
    /* webpackChunkName: "sf-create-account" */ "@/esf_antarctica_lederhosenland/core/views/authentication/sign-up/SignUp.vue"
  );
const ForgotPassword = () =>
  import(
    /* webpackChunkName: "sf-forgot-password" */ "@/esf_antarctica_lederhosenland/core/views/authentication/forgot-password/ForgotPassword.vue"
  );
const ResetPassword = () =>
  import(
    /* webpackChunkName: "sf-forgot-password" */ "@/esf_antarctica_lederhosenland/core/views/authentication/reset-password/ResetPassword.vue"
  );

const Category = () =>
  import(
    /* webpackChunkName: "sf-category-page" */ "@/esf_antarctica_lederhosenland/core/views/category-product/Category.vue"
  );

const Faq = () =>
  import(/* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/faq/Faq.vue");

const PageNotFound = () =>
  import(
    /* webpackChunkName: "sf-page-not-found" */ "@/esf_antarctica_lederhosenland/core/views/pageNotFound/pageNotFound.vue"
  );
// const PageNotFound = () =>
//   import(
//     /* webpackChunkName: "sf-page-not-found" */ "@/esf_antarctica_lederhosenland/core/views/PageNotFound.vue"
//   );
// const Category = () =>
//   import(
//     /* webpackChunkName: "sf-category-page" */ "@/esf_antarctica_lederhosenland/core/views/Category.vue"
//   );

const Login = () =>
  import(
    /* webpackChunkName: "sf-login" */ "@/esf_antarctica_lederhosenland/core/views/authentication/login/Login.vue"
  );

// const ForgotPassword = () =>
//   import(
//     /* webpackChunkName: "sf-forgot-password" */ "@/esf_antarctica_lederhosenland/core/views/ForgotPassword.vue"
//   );
// const ResetPassword = () =>
//   import(
//     /* webpackChunkName: "sf-forgot-password" */ "@/esf_antarctica_lederhosenland/core/views/ResetPassword.vue"
//   );
// const CreateAccount = () =>
//   import(
//     /* webpackChunkName: "sf-create-account" */ "@/esf_antarctica_lederhosenland/core/views/CreateAccount.vue"
//   );
const Account = () =>
  import(
    /* webpackChunkName: "sf-create-account" */ "@/esf_antarctica_lederhosenland/core/views/account/Account.vue"
  );
const CmsPage = () =>
  import(/* webpackChunkName: "sf-cms-page" */ "@/esf_antarctica_lederhosenland/core/views/static-page/StaticPage.vue");

const Product = () =>
  import(
    /* webpackChunkName: "sf-product" */ "@/esf_antarctica_lederhosenland/core/views/product-detail/Product.vue"
  );
const Cart = () =>
  import(/* webpackChunkName: "sf-cart" */ "@/esf_antarctica_lederhosenland/core/views/cart/Cart.vue");
const Checkout = () =>
  import(
    /* webpackChunkName: "sf-checkout" */ "@/esf_antarctica_lederhosenland/core/views/checkout/Checkout.vue"
  );
const PaymentSuccess = () =>
  import(
    /* webpackChunkName: "sf-payment-success" */ "@/esf_antarctica_lederhosenland/core/views/payment-info/PaymentSuccess.vue"
  );
const PaymentCancel = () =>
  import(
    /* webpackChunkName: "sf-payment-cancel" */ "@/esf_antarctica_lederhosenland/core/views/payment-info/PaymentCancel.vue"
  );
// const OurShop = () =>
//   import(/* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/OurShop.vue");
// const Brands = () =>
//   import(
//     /* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/brands/Brands.vue"
//   );
// //const Brand = () =>
// //  import(/* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/Brand.vue");

const Search = () =>
  import(
    /* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/search/Search.vue"
  );

// const Sale = () =>
//   import(/* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/Sale.vue");
// const Faq = () =>
//   import(/* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/Faq.vue");
const Contact = () =>
  import(
    /* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/contact/Contact.vue"
  );
// const Blogs = () =>
//   import(/* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/Blogs.vue");
// const Blog = () =>
//   import(/* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/Blog.vue");
const CustomerService = () =>
  import(
    /* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/customer-service/CustomerService.vue"
  );

const ComparePage = () =>
  import(
    /* webpackChunkName: "sf-our-shop" */ "@/esf_antarctica_lederhosenland/core/views/compare/ComparePage.vue"
  );

const Branches = () =>
  import(/* webpackChunkName: "sf-branches" */ "@/esf_antarctica_lederhosenland/core/views/branches/Branches.vue");

const Wishlist = () =>
  import(/* webpackChunkName: "sf-wishlist" */ "@/esf_antarctica_lederhosenland/core/views/wishlist/Wishlist.vue");

const routes = [
  { name: "home", path: "/", component: Home },
  { name: "login", path: "/login", component: Login },
  { name: "signUp", path: "/create-account", component: CreateAccount },
  {
    name: "forgotPassword",
    path: "/forgot-password",
    component: ForgotPassword,
  },
  {
    name: "reset-password",
    path: "/customer/account/createPassword",
    component: ResetPassword,
  },
  { name: "blogs", path: "/blog", component: Blogs },
  { name: "blog", path: "/blog/:code", component: Blog },

  { name: "category-page", path: "/category-page", component: Category },
  {
    name: "faq",
    path: "/faq",
    component: Faq,
  },
  {
    name: "contact",
    path: "/contact",
    component: Contact,
  },
  { name: "BrandList", path: "/merken", component: BrandList },
  { name: "BrandsDetail", path: "/merken/:code", component: BrandsDetail },

  // product
  { name: "product-SimpleProduct", path: "/product", component: Product },
  {
    name: "product-ConfigurableProduct",
    path: "/productconfig",
    component: Product,
  },
  {
    name: "product-BundleProduct",
    path: "/productbundle",
    component: Product,
  },
  {
    name: "product-page",
    path: "/product",
    component: Product,
  },

  {
    name: "product-LookProduct",
    path: "/productlook",
    component: Product,
  },
  { name: "cart", path: "/checkout/cart", component: Cart },
  { name: "account", path: "/account", component: Account },
  {
    name: "customerService",
    path: "/customer-service",
    component: CustomerService,
  },
  { name: "checkout", path: "/checkout", component: Checkout },
  {
    name: "onpagesuccess",
    path: "/checkout/onepage/success",
    component: PaymentSuccess,
  },
  {
    name: "onpagecancel",
    path: "/checkout/onepage/cancel",
    component: PaymentCancel,
  },
  {
    name: "multisafepaysuccess",
    path: "/multisafepay/connect/success",
    component: PaymentSuccess,
  },
  {
    name: "multisafepaycancel",
    path: "/multisafepay/connect/cancel",
    component: PaymentCancel,
  },
  {
    name: "compare",
    path: "/compare",
    component: ComparePage,
  },

  { name: "search", path: "/search", component: Search },
  { name: "error", path: "/error", component: PageNotFound },

  // 404
  { name: "pageNotFound", path: "/page-not-found", component: PageNotFound },

  // { name: "error", path: "/error", component: PageNotFound },
  // { name: "login", path: "/login", component: Login },
  // {
  //   name: "forgot-password",
  //   path: "/forgot-password",
  //   component: ForgotPassword,
  // },
  // {
  //   name: "reset-password",
  //   path: "/customer/account/createPassword",
  //   component: ResetPassword,
  // },
  // { name: "create-account", path: "/create-account", component: CreateAccount },
  // { name: "account", path: "/account", component: Account },
  // { name: "product-SimpleProduct", path: "/product", component: Product },
  { name: "cms-page", path: "/cms-page", component: CmsPage },
  // { name: "ourshop", path: "/winkel/:code", component: OurShop },
  // { name: "search", path: "/search", component: Search },
  // { name: "sale", path: "/sale", component: Sale },
  // { name: "brands", path: "/merken", component: Brands },
  // { name: "blogs", path: "/blog", component: Blogs },
  // { name: "blog", path: "/blog/:code", component: Blog },
  // //{ name: "brand", path: "/merken/:code", component: Brand },
  // {
  //   name: "onpagesuccess",
  //   path: "/checkout/onepage/success",
  //   component: PaymentSuccess,
  // },
  // {
  //   name: "onpagecancel",
  //   path: "/checkout/onepage/cancel",
  //   component: PaymentCancel,
  // },
  // {
  //   name: "multisafepaysuccess",
  //   path: "/multisafepay/connect/success",
  //   component: PaymentSuccess,
  // },
  // {
  //   name: "multisafepaycancel",
  //   path: "/multisafepay/connect/cancel",
  //   component: PaymentCancel,
  // },

  // { name: "category-page", path: "/category-page", component: Category },
  // {
  //   name: "product-ConfigurableProduct",
  //   path: "/productconfig",
  //   component: Product,
  // },
  // {
  //   name: "product-BundleProduct",
  //   path: "/productbundle",
  //   component: Product,
  // },
  // {
  //   name: "product-page",
  //   path: "/product",
  //   component: Product,
  // },

  // {
  //   name: "product-LookProduct",
  //   path: "/productlook",
  //   component: Product,
  // },
  // {
  //   name: "faq",
  //   path: "/faq",
  //   component: Faq,
  // },
  // { name: "page-not-found", path: "/page-not-found", component: PageNotFound },
  // {
  //   name: "contact",
  //   path: "/contact",
  //   component: Contact,
  // },
  // { name: "page-not-found", path: "/page-not-found", component: PageNotFound },
  { name: "filialen", path: "/filialen", component: Branches },
  { name: "wishlist", path: "/wishlist", component: Wishlist },
];

export default routes;
